import {Component} from '@angular/core';

@Component({
  selector: 'app-statistiche',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})

export class HomeComponent {
}
